// Pure mapper: a listing-pipeline lead → the Listing Request form's prefill
// (carried via router state when "Appt Set" offers to start the file).
// Mirrors buildIntakeLead (intakeLead.js) in reverse: every client rides
// along (primary + partner/co-clients), the stored system-source id resolves
// back to the FULL source object the form needs (submit reads its
// leadCommission), and sourceLeadId lets submit LINK this lead to the new
// file instead of minting a duplicate pipeline lead.
import { resolveSystemSource } from "./leadSourceLabel";

export function buildListingRequestPrefill(lead = {}, systemSources = []) {
  const clientinfo = [
    lead.contactId,
    ...(Array.isArray(lead.coClients)
      ? lead.coClients.map((c) => c && c.contactId)
      : []),
  ].filter(Boolean);

  const source = resolveSystemSource(lead.source, systemSources);

  return {
    sourceLeadId: String(lead.id || ""),
    clientinfo,
    agentId: lead.assignedAgent || "",
    agentName: lead.assignedAgentName || "",
    leadsource: source || "",
    leadsourceAbbreviation: (source && source.abbreviation) || "",
    listingDate: lead.appointmentAt || "",
    propertyAddress: lead.propertyAddress || "",
    notes: lead.notes || "",
  };
}
